<template>
  <component :is="layoutComponent" />
  <Analytics />
</template>

<script>
import { Analytics } from "@vercel/analytics/vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import NoLayout from "@/layouts/NoLayout.vue";

export default {
  name: "App",
  components: {
    Analytics,
    DefaultLayout,
    NoLayout,
  },
  computed: {
    layoutComponent() {
      // Exemple : Utiliser le nom de la route pour choisir le layout
      if (this.$route.name === "register" || this.$route.name === "setup-company" || this.$route.name === "login" || this.$route.name === "forgot-password" || this.$route.name === "catalog" || this.$route.name === "verification-candidate" || this.$route.name === "verification-resume" || this.$route.name === "verification-done" || this.$route.name === "landing-strasbourg") {
        return NoLayout;
      }
      return DefaultLayout;
    },
  },
};
</script>

<style type="text/css">
  .btn {
    text-transform: none !important;
  }
</style>
